import React, { useState } from "react";

import bgg from "assets/img/bgg.png";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";


export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <AdminNavbar fixed />

      <section className="xl:pt-24 lg:pt-20 md:pt-16 pt-20">
        <div
          className=" xl:pt-24 xl:pb-16 lg:pt-20 lg:pb-20 md:pt-12 md:pb-12 pt-12 pb-12"
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center", // Correct property name
            backgroundRepeat: "repeat", // No need to quote unless special characters
            backgroundSize: "55% auto", // No dash in property names
          }}
        >
          <div className="container mx-auto">
            <div className="xl:w-10/12 justify-center mx-auto text-center ">
              <p className="text-peach xl:text-3xl lg:text-3xl md:text-2xl text-2xl bubblegum">Junior Toes</p>
              <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-bold text-black pt-2">
                Frequently Asked Questions
              </h2>
              <p className="xl:text-xl text-xl mt-2 xl:mt-3" style={{ lineHeight: 1.9 }}>
                What would you like to know?
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white xl:pt-16 xl:pb-16 lg:pt-8 lg:pb-16 md:pt-6 md:pb-12 pt-6 pb-16 parkinsans xl:px-0 lg:px-4 md:px-4  px-2">
        <div className="container mx-auto ">
          <div className="flex mx-auto justify-center xl:gap-6 gap-4">
            <div className="xl:w-9/12 lg:w-7/12 md:w-11/12 w-12/12">
              {/* question 1 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 p-4 mt-12 cursor-pointer xl:mt-12"
                onClick={() => toggleAccordion(1)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What age group does Junior Toes cater to?
                    </h1>
                  </div>
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What age group does Junior<br></br> Toes cater to?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 1 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 1 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes is designed for children aged 2 to 6 years,
                      offering age appropriate programmes to nurture their
                      growth and develop
                    </p>
                  </div>
                )}
              </div>

              {/* question 2 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 p-4 mt-4 xl:mt-4"
                onClick={() => toggleAccordion(2)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What makes Junior Toes different from other preschools?
                    </h1>
                  </div>
                  {/* mobileview */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black">
                      What makes Junior Toes different<br></br> from other preschools?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 2 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 2 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes focuses on developing entrepreneurial skills
                      like leadership, teamwork, and problem-solving through
                      play-based, experiential learning. We also emphasize
                      environmental awareness and encourage critical thinking
                      through our Technology of consciousness (TOC) and Modality
                      of Consciousness (MOC) approach.
                    </p>
                  </div>
                )}
              </div>

              {/* question 3 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(3)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the teacher-to-child ratio?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 3 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 3 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      We maintain a low teacher-to-child ratio to ensure
                      personalized attention and support for each child’s
                      individual learning needs.
                    </p>
                  </div>
                )}
              </div>

              {/* question 4 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 mt-4 p-4"
                onClick={() => toggleAccordion(4)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What curriculum does Junior Toes follow?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 4 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 4 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Our curriculum and pedagogy partner is with a team of
                      International and National award winning experts who have
                      developed the Antah:Prerana way of learning. Antah:Prerana
                      way of learning blends international best practices in
                      early childhood education with entrepreneurial principles,
                      focusing on holistic development through various themes.
                    </p>
                  </div>
                )}
              </div>

              {/* question 5 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(5)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How are children prepared for primary school after Junior
                      Toes?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black">
                      How are children prepared for primary<br></br> school after Junior
                      Toes?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 5 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 5 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4 ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Junior Toes builds a strong foundation in academics,
                      social skills, and emotional resilience, ensuring a smooth
                      transition to primary school while fostering a love for
                      learning and independent thinking
                    </p>
                  </div>
                )}
              </div>

              {/* question 6 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(6)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      What safety and hygiene measures are in place?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      What safety and hygiene<br></br> measures are in place?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 6 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 6 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Safety is our top priority. Our campus is child-proofed,
                      equipped with CCTV surveillance, and maintained with
                      strict hygiene protocols. Facilitators are trained in
                      first aid and emergency handling.
                    </p>
                  </div>
                )}
              </div>

              {/* question 7 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(7)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the daily schedule like?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 7 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 7 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4 ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      The day is structured to balance learning, play, rest, and
                      meals. Activities include group sessions, outdoor play,
                      storytelling, creative workshops, and exploration time.
                    </p>
                  </div>
                )}
              </div>

              {/* question 8 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(8)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you handle separation anxiety?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 8 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 8 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      We follow a gradual settling-in process to make children
                      feel comfortable. Our facilitators provide personalized
                      attention and work closely with parents to ensure a smooth
                      transition.
                    </p>
                  </div>
                )}
              </div>

              {/* question 9 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(9)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      Are meals provided, and what is the menu like?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className=" text-base font-semibold text-black ">
                      Are meals provided, and what <br></br>is the menu like?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 9 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 9 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Yes, we provide nutritious, well-balanced meals that are
                      child friendly and cater to dietary preferences or
                      allergies. Parents are welcome to review the menu
                    </p>
                  </div>
                )}
              </div>

              {/* question 10*/}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(10)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black ">
                      How are parents involved in the learning process?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="text-base font-semibold text-black ">
                      How are parents involved in<br></br> the learning process?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 10 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 10 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      We believe in a strong home-school partnership. Parents
                      are updated regularly through newsletters, parent-teacher
                      meetings, and interactive workshops to stay involved in
                      their child’s progress.
                    </p>
                  </div>
                )}
              </div>

              {/* question 11 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(11)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      Do you offer transportation?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 11 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 11 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      Yes, we provide safe and reliable transportation services
                      with trained staff to ensure your child’s safety during
                      transit.
                    </p>
                  </div>
                )}
              </div>

              {/* question 12 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(12)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What documents are required for admission?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What documents are required<br></br> for admission?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 12 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 12 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      You will need to submit a copy of your child’s birth
                      certificate, medical records, and recent photographs.
                      Additional documents may be requested during the admission
                      process which can be seen in the apply for admission page
                    </p>
                  </div>
                )}
              </div>

              {/* question 13 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(13)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the fee structure, and are there any additional
                      costs?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What is the fee structure, and<br></br> are there any additional
                      costs?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 13 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 13 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      Our fee structure is competitive and includes tuition,
                      meals, and basic supplies. Any additional costs, such as
                      excursions or special events, will be communicated well in
                      advance.
                    </p>
                  </div>
                )}
              </div>

              {/* question 14 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(14)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you ensure equal attention to all children?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How do you ensure equal attention<br></br> to all children?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 14 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 14 && (
                  <div className="xl:mt-4 mt-4 bg-gray-100 rounded-md ">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      With a low teacher-to-child ratio and activity-based
                      learning, every child receives individualized attention
                      and support in our inclusive environment.
                    </p>
                  </div>
                )}
              </div>

              {/* question 15 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(15)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      How can I track my child’s progress
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 15 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 15 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold">
                      We provide regular progress reports and conduct
                      parent-teacher meetings. Additionally, our facilitators
                      are always available to discuss your child’s development.
                    </p>
                  </div>
                )}
              </div>

              {/* question 16 */}
              <div
                className="flex flex-col borderform rounded-xl xl:p-4 xl:mt-4 p-4 mt-4"
                onClick={() => toggleAccordion(16)}
              >
                <div className="flex justify-between">
                  <div className="flex gap-4 xl:block lg:block md:block sm:hidden hidden">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What happens if my child falls sick during school hours?
                    </h1>
                  </div>
                  {/* mobile view */}
                  <div className="flex gap-4 xl:hidden lg:hidden md:hidden sm:block block">
                    <h1 className="xl:text-xl lg:text-xl md:text-xl text-base font-semibold text-black">
                      What happens if my child falls<br></br> sick during school hours?
                    </h1>
                  </div>
                  <div className=" border-blue flex items-center h-6 w-6 rounded-full justify-center">
                    <p className="text-blue xl:text-xl text-xl">
                      {activeIndex === 16 ? "-" : "+"}
                    </p>
                  </div>
                </div>
                {activeIndex === 16 && (
                  <div className="xl:mt-4 bg-gray-100 rounded-md mt-4">
                    <p className="xl:text-lg lg:text-lg md:text-lg text-base text-black font-semibold ">
                      If a child feels unwell, our facilitators provide
                      immediate care and inform the parents promptly. We have a
                      first-aid-trained team and a doctor on call for
                      emergencies.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* <div className="xl:col-span-3">
              <div className=""
              //        style={{
              //   backgroundImage: `url(${girlll})`,
              //   width: "100%",

              //   backgroundSize: "cover",
              //   backgroundPosition: "center",
              // }}
              >
                <img className="xl:w-12/12" src={girlll} alr="" />

              </div>
            </div> */}
          </div>
        </div>
      </section>
      <Footer2 />
    </>
  );
}
